import { Injectable } from '@angular/core';
import { DatePipe   } from '@angular/common';
import { isEmpty } from 'rxjs/operators';
import { SlotVisibility } from 'src/app/beans/slot/slot.visibility.bean';
import { DateUtil } from 'src/app/utils/date.util';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';


@Injectable({
  providedIn: 'root'
})
export class TablesPipe
{
    constructor
    (
        private _datePipe: DatePipe,
        private _utils : UtilsManager
    ){}


    excapeText(value: any, escape: string)
    {
        if (!value) return escape
        return value
    } 
    
    time_pipe_seconds_to_time(time: any, escape: string)
    {
        if (!time || time == "0" || isNaN(Number(time))) return escape
        const positive =  time >= 0
        time = Math.abs( time )
        const date = new Date(0)        
        date.setSeconds(Number(time))        
        return ( positive ? "" : "- " ) + this._datePipe.transform( date, 'H:mm:ss', "GMT+0")
    }
    
    is_not_null(value: any, escape: string)
    {
        if (!value || value == "") return escape
        else return value
    }

    is_active(value: any)
    {
        if(value && value == "Y") return "pipe.value.yes"
        else                      return "pipe.value.no"
    }

    style_warner(time: any, min: number, max: number)
    {          
          
        if ( time == null || time == undefined || time == "0" || isNaN(Number(time))) return 
        
        const num = Number(time)
        if (num >= min && num <= max) {
            return {'warning-text': true  , 'font-weight-bold': true}
        }
        
        if (num >= max){
            return {'alarm-text'  : true  , 'font-weight-bold': true}
        }
    
        return
    }

    get_week_day(day: number)
    {
        switch (day) 
        {
            case 1: return "table.day.monday"
            case 2: return "table.day.tuesday"
            case 3: return "table.day.wednesday"
            case 4: return "table.day.thursday" 
            case 5: return "table.day.friday"  
            case 6: return "table.day.saturday"
            case 7: return "table.day.sunday"  
        }
    }

    get_visibility(type: number, visibilities: SlotVisibility[])
    {
        let vis = visibilities.filter(p => p.id == type)
        return vis[0].name
    }

    is_assigned(assigned: any)
    {
        if (!assigned || assigned == "0" || assigned == 0 || isNaN(Number(assigned))) return "pipe.value.no"
        return "pipe.value.yes"
    }

    is_bookable(bookable: any)
    {
        if (!bookable || bookable  == "0" || bookable == 0 || isNaN(Number(bookable))) return "pipe.value.no"
        return "pipe.value.yes"
    }

    is_sameDayBook(sameDayBook: any)
    {
        if (!sameDayBook || sameDayBook  == "0" || sameDayBook == 0 || isNaN(Number(sameDayBook))) return "pipe.value.no"
        return "pipe.value.yes"
    }

    last_date_inserted(lastDate: any)
    {
        if(lastDate)
        {
            let prevDate = this._utils.date().addDay(lastDate, -1)
            return this._utils.date().toFormat(prevDate, "dd-MM-yyyy")
        }

        return undefined
        
    }

    is_enabled(enabled: any)
    {    
        if (!enabled || enabled == "0" || enabled == 0 || isNaN(Number(enabled))) return "pipe.value.inactive"
        return "pipe.value.active"
    }

    is_bool(bool: any)
    {
        if(bool == true)
            return 1
        else
            return 0
    }
}